import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Form,
  FormGroup
} from "reactstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import "./style.css";

class PaymentSuccessModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Modal className="about-modal" isOpen={this.props.modalOpen}>
          <ModalHeader toggle={this.toggle} style={{ background: "#3E3F9B" }}>
            Booking Confirmed
          </ModalHeader>
          <ModalBody style={{ padding: "3rem 3rem 0 3rem" }}>
            <Form>
              <FormGroup row>
                <Col sm={12}>
                  <p>
                    You have booked this rental, you can now message the user by
                    going to your rentals page and selecting the rental and then
                    the user.
                  </p>
                </Col>
                <Link
                  className="loginbutton btn btn-secondary btn-lg btn-block"
                  to="/"
                  size="md"
                  block
                >
                  Continue
                </Link>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

PaymentSuccessModal.propTypes = {
  modalOpen: PropTypes.bool,
  toggle: PropTypes.func,
  size: PropTypes.string
};

export default PaymentSuccessModal;
